export function initializeExternalLinks() {
  document.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    const normalizedHref = href.toLowerCase();
    const opensFile = normalizedHref.endsWith('.pdf') || normalizedHref.endsWith('.mp4');
    const isExternal = /^https?:/i.test(href)
      && new URL(href, window.location.href).hostname !== window.location.hostname;

    if (opensFile || isExternal) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });
}
